import chroma from 'chroma-js';

import * as CPC from './colorscales';

function getColorscale(
  colorscale,
  nSwatches,
  logBreakpoints,
  log,
  colorscaleType,
) {
  /*
   * getColorscale() takes a scale, modifies it based on the input
   * parameters, and returns a new scale
   */
  // helper function repeats a categorical colorscale array N times
  const repeatArray = (array, n) => {
    let arrays = Array.apply(null, new Array(n));
    arrays = arrays.map(function () {
      return array;
    });
    return [].concat.apply([], arrays);
  };

  let cs = chroma.scale(colorscale).mode('lch');

  if (log) {
    const logData = Array(nSwatches)
      .fill()
      .map((x, i) => i + 1);
    cs = cs.classes(chroma.limits(logData, 'l', logBreakpoints));
  }

  let discreteScale = cs.colors(nSwatches);

  // repeat linear categorical ("qualitative") colorscales instead of repeating them
  if (!log && colorscaleType === 'categorical') {
    discreteScale = repeatArray(colorscale, nSwatches).slice(0, nSwatches);
  }

  return discreteScale;
}

const presetColormaps = Object.fromEntries(
  Object.entries({
    ...CPC.BUILTINS.sequential,
    ...CPC.BUILTINS.divergent,
    ...CPC.BUILTINS.categorical,
    ...CPC.BUILTINS.cyclical,
    ...CPC.CMOCEAN,
    ...CPC.OCEANUM,
    ...Object.assign(...CPC.BREWER.sequential.map((k) => ({ [k]: k }))),
    ...Object.assign(...CPC.BREWER.divergent.map((k) => ({ [k]: k }))),
    ...Object.assign(...CPC.BREWER.categorical.map((k) => ({ [k]: k }))),
  }).map(([k, v]) => [k.toLowerCase(), v]),
);

const getPresetColormap = (colormap, ncolors = 10) => {
  const preset =
    presetColormaps[colormap.scale.toLowerCase()] || presetColormaps['thermal'];
  if (!preset.scale) {
    const scale = getColorscale(preset, ncolors);
    return { scale, domain: colormap.domain || [0, 1] };
  } else {
    if (colormap.domain) {
      const dmin = Math.min(...colormap.domain);
      const dmax = Math.max(...colormap.domain);
      const ind = preset.domain.map((d) => d >= dmin && d <= dmax);
      return {
        scale: preset.scale.filter((d, i) => ind[i]),
        domain: preset.domain.filter((d, i) => ind[i]),
      };
    } else {
      return preset;
    }
  }
};

export { getPresetColormap, presetColormaps };
